module.exports = "/_next/static/images/4e4bebd93ed4ba82f62112b45bfc08a1-promo-hot-sale.jpg";